const Web3 = require("web3")
let auctionParsed = require('./Auction.json');
let assetsParsed = require('./Assets.json');
import {CONTRACT_ADDRESS, CHAIN_ID} from '../constants/project_variables';
import { SAVE_BID } from "../constants/urls";
import eventBus from './globalPubSub';

const chainId = CHAIN_ID;
const supportedChains = ["0x13881", "0x89", CHAIN_ID]

let CHAIN_ID_EXCHANGE_CONTRACT_DICT = {};
CHAIN_ID_EXCHANGE_CONTRACT_DICT[CHAIN_ID] = CONTRACT_ADDRESS;

const CHAIN_DETAILS_DICT = {
    '0x89':{
	"networkName": "Polygon Mainnet",
	"networkUrl": "https://polygon-rpc.com/",
	"currencySymbol": "MATIC",
	"blockExplorer": "https://polygonscan.com"
    },
    '0x13881':{
	"networkName": "Polygon Testnet Mumbai",
	"networkUrl": "https://matic-mumbai.chainstacklabs.com",
	"currencySymbol": "MATIC",
	"blockExplorer": "https://mumbai.polygonscan.com"
    },
}

export async function getGlipBalance(chainId){
    let {isConnected, accounts} = await checkConnection();
    if(!isConnected){
	return;
    }
    const exchangeContract = CHAIN_ID_EXCHANGE_CONTRACT_DICT[CHAIN_ID];
    console.log('exchangeContract found', exchangeContract)
    if(!exchangeContract){
	return 0
    }
    accounts = await window.ethereum.request({ method: 'eth_accounts' });
    const web3 = new Web3(window.ethereum);
    var abi = auctionParsed.abi;
    console.log('exchangeContract', exchangeContract);
    var auctionContract = new web3.eth.Contract(abi, exchangeContract);
    console.log('legend acc', accounts[0])
    let val = await auctionContract.methods.getStake(accounts[0]).call();
    val = Web3.utils.fromWei(val, 'ether')
    console.log(val)
    return val;
}

export async function getNFTBalance(assetContract, address){
    console.log(assetContract)
    const web3 = new Web3(window.ethereum);
    var abi = assetsParsed.abi;
    console.log('assetContract', assetContract);
    var contract = new web3.eth.Contract(abi, assetContract);
    let val = await contract.methods.balanceOf(address).call();
    // val = Web3.utils.fromWei(val, 'ether')
    console.log(val)
    return val;
}


export async function getTokenOfOwnerByIndex(assetContract, address, tokenId){
    const web3 = new Web3(window.ethereum);
    var abi = assetsParsed.abi;
    console.log('assetContract', assetContract);
    var contract = new web3.eth.Contract(abi, assetContract);
	// var batch = new web3.BatchRequest();
	// for(var i=0; i<tokenIds; i++) {
	// 	batch.add(contract.methods.tokenOfOwnerByIndex(address, i).call());
	// }
	// batch.execute();

    let val = await contract.methods.tokenOfOwnerByIndex(address, tokenId).call();
    // val = Web3.utils.fromWei(val, 'ether')
    console.log(val)
    return val;
}


export async function getTokenURI(assetContract, tokenId){
    const web3 = new Web3(window.ethereum);
    var abi = assetsParsed.abi;
    console.log('assetContract', assetContract);
    var contract = new web3.eth.Contract(abi, assetContract);
    let val = await contract.methods.tokenURI(tokenId).call();
    console.log(val)
    return val;
}


export async function connectWallet(){
    console.log('connect wallet called');
    const web3 = new Web3(window.ethereum);
    let accounts = await web3.eth.getAccounts();
    console.log(accounts)
    if(!accounts.length){	
	let accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
    }
    accounts = await web3.eth.getAccounts();
    if(accounts.length>0){
	
        eventBus.dispatch('public-address-found', accounts[0]);
    }
    return accounts;  
}


export async function getPublicAddress(){
    console.log('connect wallet called');
    const web3 = new Web3(window.ethereum);
    let accounts = await web3.eth.getAccounts();
    console.log('accountgg', accounts);
    console.log('accountgg', accounts[0]);
    return accounts[0];  
}


export async function checkConnection(){
    if (typeof window.ethereum === 'undefined') {
	return {isConnected:false, accounts:[]};  
    }
    const web3 = new Web3(window.ethereum);
    let accounts = await web3.eth.getAccounts();
    if(accounts.length > 0){
	console.log('accounts', accounts);
        eventBus.dispatch('public-address-found', accounts[0]);
	return {isConnected:true, accounts:accounts};
    }
    eventBus.dispatch('public-address-found', undefined);
    return {isConnected:false, accounts:accounts};  
}

export async function sendSignedForm(
    item:any, bidValue:string, exchangeContractAddress,
    cb:any, cbError:any){
    let publicAddress = await getPublicAddress();
    const web3 = new Web3(window.ethereum);
    bidValue = Web3.utils.toWei(bidValue);

    let chainIdStr = convertFromHexToNumber(chainId)
    let msgParams =  JSON.stringify({
	"types": {
	    EIP712Domain:[
		{name:"name",type:"string"},
		{name:"version",type:"string"},
		{name:"chainId",type:"uint256"},
		{name:"verifyingContract",type:"address"}
	    ],
	    Bid: [
		{
		    "name": "maker",
		    "type": "address"
		},
		{
                    "name": "taker",
                    "type": "address"
		},
		{
                    "name": "token",
                    "type": "address"
		},
		{ 
		    "name": "auctioneer",
		    "type": "address" 
		},
		{
                    "name": "tokenId",
                    "type": "uint256"
		},
		{
                    "name": "value",
                    "type": "uint256"
		},
		{
                    "name": "start",
                    "type": "uint256"
		},
		{
                    "name": "end",
                    "type": "uint256"
		},
		{
		    "name": "tokenData",
		    "type": "bytes"
		},
        ]
	},
	"domain": {
	    "name": "Exchange",
	    "version": "1",
	    "chainId": chainIdStr,
	    "verifyingContract": exchangeContractAddress
	},
	primaryType:"Bid",
	"message": {
	    "maker": publicAddress,
	    "taker": publicAddress,
	    "token": item.token,
	    "auctioneer": item.auctioneer,
	    "tokenId": item.tokenId,
	    "value": bidValue,
	    "start": 0,
	    "end": 2529772200,
	    "tokenData": item.encodedFormBytes,
	},
    });
    
    var params = [publicAddress, msgParams];
    let method = 'eth_signTypedData_v4'

    let signature = web3.currentProvider.send(
	{method,
	 params,
	 publicAddress}, async (err, result) => {
	     let parsedMessageParams = JSON.parse(msgParams);
	     if (err) {
		 console.log('err');
		 console.log(err);
		 cbError(err.message);
		 return;
	     }
	     if (result.error) {
		 console.log('result.error', result.error);
		 cbError(result.error)
		 return;
	     }
	     console.log(result);
	     parsedMessageParams.signature = result.result;
	     const rawResponse = await fetch(SAVE_BID, {
		 method: 'POST',
		 headers: {
		     'Accept': 'application/json',
		     'Content-Type': 'application/json'
		 },
		 body: JSON.stringify({assetId: item._id, auctionId: item.auctionId, form:parsedMessageParams})
	     });
	     const content = await rawResponse.json();
	     
	     console.log(content);
	     if(content.success){
		 cb();
		 return
	     }
	     cbError(content.message);
    });
    console.log(signature);  
}

async function switchChain(chainId:string){
    let resp;
    try{
	resp = await window.ethereum.request({
	    method: 'wallet_switchEthereumChain',
	    params:[{chainId: chainId}]
	});
    }
    catch(e){
	console.log('error legend', e.message.indexOf('Unrecognized chain ID'));
	if(e.message.indexOf('Unrecognized chain ID') != -1){
	    console.log('returning bitches');
	    return -1;
	}
    }
    return true;
}

async function addChain(chainId:string){
    let chainDetails = CHAIN_DETAILS_DICT[chainId];
    let resp;
    try{
	resp = await window.ethereum.request({
	    method: 'wallet_addEthereumChain',
	    params: [{
		chainId: chainId,
		chainName: chainDetails.networkName,
		nativeCurrency: {
		    name: 'MATIC',
		    symbol: chainDetails.currencySymbol,
		    decimals: 18
		},
		rpcUrls: [chainDetails.networkUrl],
		blockExplorerUrls: [chainDetails.blockExplorer]
	    }]
	})
    }
    catch(error){
	console.log(error)
	return error;
    }
    console.log('success resp', resp);
    return resp;
}


export async function handleSwitchChain(chainId:string){
    let response = await switchChain(chainId);
    console.log('switch chain response', response);
    if(response === true){
	return true;
    }
    if(response === -1){
	console.log('adding chain now bitches');
	let resp = await addChain(chainId);
	if(resp===null){
	    console.log('chainzzz bitches');
	    //this shit is inaccurate
	    console.log(window.ethereum.chainId);
	    return null;
	    //just return null then maybe use a settimeout
	    // to figure out if chainid is now goodzz
	}
	else if(resp.message === "User rejected the request."){
	    console.log('dams user reject');
	    return false
	}
    }
}


export function checkIfActiveChain(tchainId:string){
    console.log('tchainId', tchainId)
    if (typeof window.ethereum === 'undefined') {
	return false
    }
    if(tchainId){
	if(window.ethereum.chainId === tchainId){
	    return true;
	}
	else{
	    return false;
	}
    }
    console.log('window.ethereum.chainId', window.ethereum.chainId);
    console.log(window.ethereum.chainId);
    console.log('chainId legenddd', tchainId);    
    if(supportedChains.includes(window.ethereum.chainId)){
	console.log('all good')
	return true;
    }
    return false
}

export function convertToHex(str){
    const web3 = new Web3(window.ethereum);
    console.log('hex value', web3.utils.toHex(str));
    return web3.utils.toHex(str);
}

export function convertFromHexToNumber(str){
    const web3 = new Web3(window.ethereum);
    console.log('hex value', web3.utils.hexToNumber(str));
    return web3.utils.hexToNumber(str);
}


export function isAddress(address) {
    return Web3.utils.isAddress(address)
};
